import React__default from 'react';
import { useStyles } from '@sravni/react-utils';

var modules_f6cf120c = {"wrapper":"_jnbu1k","overlay":"_15q56ij","overlayActive":"_2fl0j4"};
import "./assets/ContentOverlay.css";

var ContentOverlay$1 = function (_a) {
    var isActive = _a.isActive, hideOverlay = _a.hideOverlay, children = _a.children;
    var cx = useStyles(modules_f6cf120c);
    return (React__default.createElement("div", { className: modules_f6cf120c.wrapper },
        children,
        React__default.createElement("div", { className: cx('overlay', { overlayActive: isActive }), onClick: hideOverlay })));
};

export { ContentOverlay$1 as ContentOverlay };
